import {
    ProjectService
} from '@/common/api.service.js'

export class Project {
    constructor ({
        company = {},
        creator = {},
        created_at = null,
        id = null,
        project_name = null,
        project_creator = null,
        project_status = 0,
        project_parent = null,
        project_company = null,
        sons = [],
        tasks = [],
        updated_at = null
    } = {}) {
        this.company = company
        this.created_at = created_at
        this.creator = creator
        this.id = id
        this.project_company = project_company
        this.project_creator = project_creator
        this.project_name = project_name
        this.project_parent = project_parent
        this.project_status = project_status
        this.sons = sons
        this.tasks = tasks
        this.updated_at = updated_at
    }

    get progress () {
        var totalTasks = this.tasks.length
        var taskDone = this.tasks.filter(function (t) {
            return t.task_status === 1
        }).length
        var percent = (taskDone / totalTasks) * 100
        return isNaN(percent) ? 0 : Math.round(percent)
    }
}

export function responseAdapter (response) {
    return new Project({
        ...response
    })
}

export function requestAdapter (request) {
    return request
}

export function queryAdapter (query) {
    if (!query._page) return query
    let offset = query._page - 1 * query._limit
    if (offset > 0) query._offset = offset
    return query
}

export default {
    getSingle: id => new Promise((resolve, reject) => {
        ProjectService.get(id)
            .then(({
                data
            }) => {
                resolve({
                    data: responseAdapter(data)
                })
            }).catch(e => {
                reject(e)
            })
    }),
    getList: params => new Promise((resolve, reject) => {
        ProjectService.query(queryAdapter(params))
            .then(({
                data,
                headers
            }) => {
                resolve({
                    data: data.map(x => responseAdapter(x)),
                    headers
                })
            }).catch(e => {
                reject(e)
            })
    }),
    create: project => new Promise((resolve, reject) => {
        ProjectService.create(requestAdapter(project))
            .then((
                data
            ) => {
                resolve(data)
            }).catch(e => {
                reject(e)
            })
    }),
    update: project => new Promise((resolve, reject) => {
        ProjectService.update(project)
            .then((
                data
            ) => {
                resolve(data)
            })
            .catch(e => {
                reject(e)
            })
    }),
    delete: id => new Promise((resolve, reject) => {
        ProjectService.delete(id)
            .then((
                data
            ) => {
                resolve(data)
            })
            .catch(e => {
                reject(e)
            })
    })
}
